module.exports = __webpack_public_path__ + "img/registration_hover_2df38c0.webp";